"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _OverviewContactInfo = _interopRequireDefault(require("../OverviewContactInfo"));
var UserIcon = function UserIcon(props) {
  return /*#__PURE__*/_react.default.createElement("svg", props, /*#__PURE__*/_react.default.createElement("path", {
    d: "M12 5a3 3 0 1 0 0 6 3 3 0 0 0 0-6zM7 8a5 5 0 1 1 10 0A5 5 0 0 1 7 8zm2.321 6.533A7.001 7.001 0 0 1 19 21a1 1 0 1 1-2 0 5 5 0 1 0-10 0 1 1 0 1 1-2 0 7 7 0 0 1 4.321-6.467z"
  }));
};
UserIcon.defaultProps = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "currentColor",
  viewBox: "0 0 24 24"
};
var stringValidator = function stringValidator(value) {
  var isValid = true;
  if (value && value.trim() === '') {
    isValid = false;
  }
  if (value === null || value === '') {
    isValid = true;
  }
  return {
    isValid: isValid,
    errorMessage: 'Invalid name'
  };
};
var OverviewContactName = function OverviewContactName(_ref) {
  var asset = _ref.asset,
    canEdit = _ref.canEdit,
    updateContactInfo = _ref.updateContactInfo;
  var renderIcon = function renderIcon() {
    return /*#__PURE__*/_react.default.createElement(UserIcon, null);
  };
  var renderField = function renderField() {
    return asset.contactName;
  };
  return /*#__PURE__*/_react.default.createElement(_OverviewContactInfo.default, {
    asset: asset,
    canEdit: canEdit,
    updateContactInfo: updateContactInfo,
    valueValidator: stringValidator,
    renderIcon: renderIcon,
    renderField: renderField,
    actionMethod: "updateContactName",
    placeholder: "Add name",
    fieldLabel: "Contact name"
  });
};
var _default = exports.default = OverviewContactName;
//# sourceMappingURL=OverviewContactName.js.map